import { render, staticRenderFns } from "./logoperation.vue?vue&type=template&id=195f2872&"
import script from "./logoperation.vue?vue&type=script&lang=js&"
export * from "./logoperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports